import {Component, inject, signal} from "@angular/core";
import {CommonModule} from "@angular/common";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {UserService} from "../../../services/user.service";
import {StorageService} from "../../../shared/data-access/storage.service";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";

export interface UserData {
  username: string;
  password: string;
}

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  userService = inject(UserService);
  storageService = inject(StorageService);
  hide = signal<boolean>(true);

  public loginForm: FormGroup = new FormGroup({
    username: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required]),
  });

  async onSubmit(): Promise<void> {
    const userData: UserData = this.loginForm.value;

    const isValid = this.validateInfo(userData);

    if (isValid) {
      this.storageService.clearError();
      this.userService.login$.next(userData);
    }
  }

  validateInfo(userData: UserData): boolean {
    return userData.username.trim() !== "" && userData.password.trim() !== "";
  }
}
